module.exports = __webpack_public_path__ + "img/auth-img.d609c17d.svg";